'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import {
  type AdBrand,
  type AdSlotName,
  AdsBanner,
} from '@/app/(app)/app/(classroom)/sala/curso/[id]/_components/ads-banner'
import {
  type FilterableProductType,
  PRODUCT_TYPE_QUERY_KEY,
  resolveProductType,
} from '@/helpers/products-filter-type'

// Cada listagem tem o seu slot do Ad Manager no lugar do banner estático.
const SLOT_BY_PRODUCT_TYPE: Record<FilterableProductType, AdSlotName> = {
  course: 'cursos_livres_topo',
  postgraduate: 'pos_graduacao_topo',
  track: 'trilhas_topo',
  webinar: 'topo_webinars',
}

interface ListingTopBannerProps {
  readonly brand: AdBrand
}

export function ListingTopBanner({ brand }: ListingTopBannerProps) {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const productType = resolveProductType({
    slug: pathname.split('/').filter(Boolean)[1],
    type: searchParams.get(PRODUCT_TYPE_QUERY_KEY),
  })

  return (
    <AdsBanner
      brand={brand}
      key={productType}
      slot={SLOT_BY_PRODUCT_TYPE[productType]}
    />
  )
}
